import Repository from './Repository';
import { MeasurementCategory } from '@/models/Measurement/MeasurementCategory';
import {AxiosResponse} from "axios";
import {ListResult} from "@/utils/API/ResultTypes/ListResult";
import {Measurement} from "@/models/Measurement/Measurement";

const resource = '/Measurements';

export default {
  listServingSizeMeasurements() {
    return Repository.get(`${resource}/ListServingSizeMeasurements`, { withCredentials: true });
  },
  listMeasurementsForCategory(category: MeasurementCategory): Promise<AxiosResponse<ListResult<Measurement>>> {
    return Repository.post(`${resource}/ListMeasurementsForCategory`, { category: category }, { withCredentials: true });
  },
};
